
import EditComponent from "../../../components/shipping_orders/Edit.vue";

export default {
  components: {
    EditComponent
  }
};
